module.exports = __webpack_public_path__ + "static/media/MaquinaTela.7d7b9701.jpg";